import supportedLocales from '../../config/supported-locales'

/**
 * Retrieves and returns a list with all supported localizations
 *
 *@returns {Array} an array containing all supported localizations.
 */
export function getSupportedLocales() {
  const annotatedLocales = []
  for (const code of Object.keys(supportedLocales)) {
    annotatedLocales.push({
      code,
      name: supportedLocales[code]
    })
  }
  return annotatedLocales
}

/**
 * Checks if the given localization is supported by accesing the underlying list.
 *
 * @param {string} locale the given localization that may be provided
 * @returns {boolean} locale if the given localization is available
 */
export function supportedLocalesInclude(locale) {
  return Object.keys(supportedLocales).includes(locale)
}
